import { createReducer, updateObject } from "../../utils/reduxHelper";
import constants from "./constants";

const initialState = {
  getDashboardLoading: false,
  getDashboardSuccess: false,
  getDashboardError: null,
  dashboardData: [],
};

/*
 * Get Dashboard 
 */
const getDashboardBegin = state =>
  updateObject(state, { getDashboardLoading: true });
const getDashboardSuccess = (state, action) =>
  updateObject(state, {
    getDashboardLoading: false,
    getDashboardError: null,
    getDashboardSuccess: true,
    dashboardData: action.payload.data,
  });
const getDashboardFailure = (state, action) =>
  updateObject(state, {
    getDashboardLoading: false,
    getDashboardError: action.payload,
  });

/**
 * Handlers
 */

const handlers = {};
handlers[constants.GET_DASHBOARD_BEGIN] = getDashboardBegin;
handlers[constants.GET_DASHBOARD_SUCCESS] = getDashboardSuccess;
handlers[constants.GET_DASHBOARD_FAILURE] = getDashboardFailure;

const dashboardReducer = createReducer(initialState, handlers);

export default dashboardReducer;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducer.js